import React from 'react';
import PdfDeck from '../PdfDeck';

function Murthal() {
  return <PdfDeck file='/machines-pdfs/mushroom_farm_murthal.pdf' />;
}

export default Murthal;
